<template>
  <table v-if="lines.length" class="lines-table">
    <thead>
      <tr>
        <th>SKU</th>
        <th>Name</th>
        <th>Registered qty</th>
        <th>On hand qty</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="line in lines" :key="line.id">
        <td>{{ line.product.sku }}</td>
        <td>{{ line.product.name }}</td>
        <td>{{ line.qty }}</td>
        <td>{{ line.onHand }}</td>
      </tr>
    </tbody>
  </table>
  <span v-else>-</span>
</template>

<script lang="ts">
import type { InventoryInboundReceiptLine } from '@/types/Models/InventoryInboundReceiptLine'
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'InboundReceiptLinesTable',
  props: {
    lines: {
      type: Array as PropType<InventoryInboundReceiptLine[]>,
      required: true,
    },
  },
})
</script>

<style scoped>
.lines-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  margin: 16px 0;

  th {
    font-weight: 600;
    color: #6c757d;
    padding: 6px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    white-space: nowrap;
  }

  td {
    padding: 8px 16px;
    vertical-align: middle;
  }

  tr + tr td {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
  }
}
</style>
